import React, { useMemo } from 'react';
import GroupBlock from './GroupBlock';
import MetricTile from './MetricTile';
import { buildKom, type Destination, type KomState } from '../../lib/kom';
import type { FunnelCounters } from '../../lib/funnel';
import type { BandTab } from '../../hooks/useBandRoute';

interface KeyOperatingMetricsProps {
  counters: FunnelCounters;
  state?: KomState;
  onShowTab?: (tab: BandTab) => void;
  onOpenFeed?: (view: 'active' | 'suppressed') => void;
}

/** The twelve metrics in three groups: Load, Timing and Quality (items 12, 14, 54, 59, 64, 66). */
const KeyOperatingMetrics: React.FC<KeyOperatingMetricsProps> = ({
  counters,
  state = 'ready',
  onShowTab,
  onOpenFeed,
}) => {
  const groups = useMemo(() => buildKom(counters, state), [counters, state]);

  const open = (destination: Destination) => {
    if (destination.kind === 'feed') onOpenFeed?.(destination.view);
    else onShowTab?.(destination.tab);
  };

  return (
    <div>
      <div className="c3-kom-groups">
        {groups.map((group) => (
          <GroupBlock key={group.id} group={group}>
            {group.tiles.map((tile) => (
              <MetricTile key={tile.id} tile={tile} onOpen={open} />
            ))}
          </GroupBlock>
        ))}
      </div>
    </div>
  );
};

export default KeyOperatingMetrics;
